import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_app/inspection/')({
	beforeLoad: () => {
		throw redirect({ to: '/inspection/library' });
	},
});
